import React from "react";
import { useNavigate } from "react-router-dom";
import { usePacote } from "../../core/common/PacoteContext/PacoteContext";
import { all_routes } from "../router/all_routes";
import styles from "./styles/ExploreCitiesSection.module.css";
import {t} from "../../lang/index"

const ExploreCitiesSection: React.FC<{ servicoId?: number }> = ({ servicoId }) => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const { setPacotes } = usePacote();

  const cities = [
    { nome: "Lisboa", img: "/assets/img/cities/belem.jpg" },
    { nome: "Almada", img: "/assets/img/cities/almada.jpg" },
    { nome: "Porto", img: "/assets/img/cities/porto.jpg" },
    { nome: "Braga", img: "/assets/img/cities/braga.jpg" },
    { nome: "Cascais", img: "/assets/img/cities/cascais.jpg" },
  ];

  const handleSearchByCity = async (cidade: string) => {
    try {
      const params = new URLSearchParams();
      params.append("termo", cidade);
      if (servicoId) params.append("servicoId", servicoId.toString());

      const res = await fetch(`${BASE_URL}/pacotes/search?${params.toString()}`);
      if (!res.ok) throw new Error("Erro ao buscar pacotes");

      const result = await res.json();
      setPacotes(result);
      navigate(all_routes.flightGrid);
    } catch (err) {
      console.error("Erro ao buscar pacotes:", err);
    }
  };

  return (
    <section className={styles.section}>
      <div className="container">
        {/* Título */}
        <div className={styles.sectionTitle}>
          <h2>{t("home.exploreCities.title")}</h2>
          <p>{t("home.exploreCities.subtitle")}</p>
        </div>

        {/* Grid */}
        <div className={styles.grid}>
          {/* Linha 1 */}
          <div className={styles.rowTwo}>
            {cities.slice(0, 2).map((c) => (
              <div
                key={c.nome}
                onClick={() => handleSearchByCity(c.nome)}
                className={`${styles.cityCard} ${styles.cityLarge}`}
              >
                <img src={c.img} alt={c.nome} className={styles.cityImage} />
                <div className={styles.cityOverlay}>
                  <h3 className={`${styles.cityTitle} ${styles.cityLarge}`}>{c.nome}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* Linha 2 */}
          <div className={styles.rowThree}>
            {cities.slice(2).map((c) => (
              <div
                key={c.nome}
                onClick={() => handleSearchByCity(c.nome)}
                className={`${styles.cityCard} ${styles.citySmall}`}
              >
                <img src={c.img} alt={c.nome} className={styles.cityImage} />
                <div className={styles.cityOverlay}>
                  <h3 className={`${styles.cityTitle} ${styles.citySmall}`}>{c.nome}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreCitiesSection;
